import React from 'react';
import Loading from "./Loading";

const LoadingFullContainer = (value)=>{
    return(
        <div className="loading-container loading-container-full">
            <Loading>{value.children}</Loading>
        </div>
    )
}

export default LoadingFullContainer;
